module.exports = __webpack_public_path__ + "img/p-three-step-01.c7d34557.png";